document.addEventListener('DOMContentLoaded', function () {
    const selectors = {
        section: '[data-blog-section]',
        searchInput: '[data-blog-search]',
        searchForm: '[data-search-form]',
        articlesRow: '[data-articles-row]',
        paginationContainer: "[data-pagination-container]",
        noResultsText: "[data-no-results-text]",
        paginationItem: "[data-pagination-item]",
        loader: "[data-loader]",
        accordionTrigger: "[data-blog-accordion-trigger]",
        popup: "[data-filter-popup]",
        popupTrigger: "[data-filter-popup-trigger]",
        filterCheckbox: "[data-filter-checkbox]",
        appliedTagsCount: "[data-applied-filters-count]",
        appliedTagsContainer: "[data-applied-tags]",
        appliedTagCol: "blog-filter__applied-tag-col",
        appliedTag: "blog-filter__applied-tag",
        removeTag: "[data-remove-tag]",
        clearAllTagsButton: "[data-clear-filter]",
        applyButton: "[data-apply-filter]"
    }

    const classes = {
        hide: 'hide',
        loading: "loading",
        active: "active"
    }

    const text = {
        noResultSearch: 'No results',
        noResultFilters: 'There is no result matching your filter'
    }

    const close_icon = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">\n' +
        '<path d="M12 4L4 12" stroke="#6C6C6C" stroke-linecap="round" stroke-linejoin="round"/>\n' +
        '<path d="M4 4L12 12" stroke="#6C6C6C" stroke-linecap="round" stroke-linejoin="round"/>\n' +
        '</svg>'

    const section = document.querySelector(selectors.section);
    const searchForm = document.querySelector(selectors.searchForm);
    const noResultsText = document.querySelector(selectors.noResultsText);
    const articlesRow = document.querySelector(selectors.articlesRow);
    const appliedTagsCount = document.querySelector(selectors.appliedTagsCount);
    const paginationContainer = document.querySelector(selectors.paginationContainer);
    const loader = document.querySelector(selectors.loader);
    const accordionTriggers = document.querySelectorAll(selectors.accordionTrigger);
    const popup = document.querySelector(selectors.popup);
    const popupTriggers = document.querySelectorAll(selectors.popupTrigger);
    const filterCheckboxes = document.querySelectorAll(selectors.filterCheckbox);
    const clearAllTagsButtons = document.querySelectorAll(selectors.clearAllTagsButton);
    const appliedTagsContainer = document.querySelector(selectors.appliedTagsContainer);
    const applyButton = document.querySelector(selectors.applyButton);

    const blogTag = `tag:${section.dataset.blogTag}`;
    const formAction = '/search?view=custom-blog&type=article';
    const defaultUrl = `${formAction}&q=${blogTag}`;

    const mediaQuery = '(max-width: 991px)';
    const mediaQueryList = window.matchMedia(mediaQuery);

    let dynamicUrlFiltration;
    let searchValue = '';

    let filtersObj = {};
    let appliedTags = [];

    function toggleLoader(show) {
        loader.classList.toggle(classes.loading, show);
    }

    function uncheckCheckboxes(checkbox) {
        if(!checkbox) {
            return;
        }

        if (checkbox.length > 1) {
            checkbox.forEach(function (checkbox) {
                checkbox.checked = false;
            });
        } else {
            checkbox.checked = false;
        }
    }

    function toggleButtonsState() {
        clearAllTagsButtons.forEach(function (clearAllTagsButton) {
            clearAllTagsButton.classList.toggle(classes.hide, !appliedTags.length);
        });

        applyButton.classList.toggle(classes.hide, !appliedTags.length);
    }

    function insertAppliedTags() {
        let tagsHtml = '';

        if (appliedTags.length) {
            tagsHtml = ` <div class="${selectors.appliedTagCol} ${selectors.appliedTagCol}--clear"><button class="blog-filter__clear" data-clear-filter>Clear Filters</button></div>`;

            appliedTags.forEach(function ([tag, tagValue]) {
                tagsHtml += `
                <div class="${selectors.appliedTagCol}">
                     <div class="${selectors.appliedTag}">
                        ${tagValue}

                        <button data-remove-tag="${tag}">
                            ${close_icon}
                        </button>
                     </div>
               </div>`
            });

            appliedTagsContainer.innerHTML = tagsHtml;
        } else {
            appliedTagsContainer.innerHTML = '';
        }
    }

    function setAppliedTagsCount() {
        appliedTagsCount.innerText = appliedTags.length ? `(${appliedTags.length})` : '';
    }

    async function fetchArticles(url) {
        toggleLoader(true);

        let response = await fetch(url, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
            }
        }).then(response => response.json());

        articlesRow.innerHTML = response.articles;
        paginationContainer.innerHTML = response.pagination;

        toggleNoResultsTexts(response.results_total === 0);
    }

    function updatePage(checkboxes) {
        let url = generateUrl();

        fetchArticles(url).then(() => {
            toggleLoader(false);
            insertAppliedTags();
            toggleButtonsState();
            setAppliedTagsCount();
            uncheckCheckboxes(checkboxes);
        });
    }

    function toggleNoResultsTexts(show) {
        if (show) {
            noResultsText.classList.remove(classes.hide);

            if (!Object.keys(filtersObj).length) {
                noResultsText.innerText = `${text.noResultSearch} ${searchValue}`;
            } else {
                noResultsText.innerText = text.noResultFilters;
            }

        } else {
            noResultsText.classList.add(classes.hide)
        }
    }

    function setHistory(filterArrays) {
        const values = [...new Set(filterArrays.flat())];
        const queryObjectParams = new URLSearchParams();
        queryObjectParams.set('q', values.join('***'));

        const queryParams = values.length ? `?${queryObjectParams.toString()}` : '';
        const newUrl = `${window.location.origin}${window.location.pathname}${queryParams}`;

        window.history.pushState(null, null, newUrl);
    }

    function generateUrl() {
        let filterArrays = Object.values(filtersObj);
        let filtersString = '';

        filterArrays.forEach(function (array) {
            let string = '';

            const tagsArray = array.map((element) => {
                return `tag:"${element}"`;
            });

            if (array.length > 1) {
                string = '(' + tagsArray.join(' OR ') + ')';
            } else {
                string = tagsArray[0];
            }

            if (filtersString.length) {
                filtersString += ' AND ' + string;
            } else {
                filtersString = string;
            }
        });

        if (searchValue) filtersString += ' ' + searchValue;

        setHistory(filterArrays);

        return `${formAction}&q=${filtersString.length ? blogTag + ' AND ' + filtersString : blogTag}`;
    }

    function toggleAccordion() {
        let panel = this.nextElementSibling;

        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = "200px";
        }

        this.classList.contains(classes.active)
            ? setTimeout(() => {
                this.classList.toggle(classes.active);
            }, 200)
            : this.classList.toggle(classes.active);
    }

    function togglePopup(unlock) {
        let isOpen = popup.classList.contains(classes.active);

        if (unlock || isOpen) {
            popup.classList.remove(classes.active);
            document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
        } else {
            popup.classList.add(classes.active);
            document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: popup}));
        }
    }

    function toggleFilter(event) {
        let filterValue = this.dataset.filterCheckbox;
        let filterArr = this.value.split("__").pop().split("_");
        let filterCategory = filterArr[0];

        if (this.checked) {
            if (!filtersObj.hasOwnProperty(filterArr[0])) {
                filtersObj[filterCategory] = [this.value];
            } else {
                filtersObj[filterCategory].push(this.value);
            }

            appliedTags.push([this.value, filterValue]);

        } else {
            let filterValueIndex = filtersObj[filterCategory].indexOf(this.value);

            if (filterValueIndex >= 0) filtersObj[filterCategory].splice(filterValueIndex, 1);
            if (!filtersObj[filterCategory].length) delete filtersObj[filterCategory];

            let arrIndex = appliedTags.findIndex((el) => { return el[0] === this.value; });

            appliedTags.splice(arrIndex, 1);
        }

        // Check and open by history
        if (event.type === 'change' || event.detail?.update) {
            updatePage();


            setTimeout(() => {
                accordionTriggers.forEach(function (accordionTrigger) {
                    const parent = accordionTrigger.closest('.blog-filter__category');
                    const inputs = parent.querySelectorAll(selectors.filterCheckbox);
                    if (!inputs.length) return false;

                    const checkedCheckboxes = Array.from(inputs).filter((input) => input.checked);
                    if (checkedCheckboxes?.length && !accordionTrigger.classList.contains(classes.active)) accordionTrigger.dispatchEvent(new Event('click'));
                });
            }, 300);
        }
    }

    function deleteAllTags() {
        filtersObj = {};
        appliedTags = [];

        updatePage(filterCheckboxes);
    }

    function deleteTag(tag) {
        let tagValue = tag.dataset.removeTag;

        Object.entries(filtersObj).forEach(([key, value]) => {
            if (value.indexOf(tagValue) >= 0) {
                value.splice(value.indexOf(tagValue), 1);

                if (!value.length) {
                    delete filtersObj[key];
                }

                let arrIndex = appliedTags.findIndex((el) => { return el[0] === tagValue; });

                appliedTags.splice(arrIndex, 1);
            }
        });

        let currentCheckbox = [...filterCheckboxes].find(function (checkbox) {
            return checkbox.value === tagValue;
        })

        updatePage(currentCheckbox);
    }

    function initPage() {
        const queryParams = new URLSearchParams(window.location.search);

        if (!queryParams.has('q')) {
            fetchArticles(defaultUrl).then(r => {
                toggleLoader(false);
            });
        }

        document.addEventListener('input', debounce(searchAction, 300, false));
        searchForm.addEventListener('submit', event => event.preventDefault());

        mediaQueryList.addEventListener('change', event => {
            if (!event.matches) {
                togglePopup(true);
            }
        });

        document.addEventListener('click', function (e) {
            let target = e.target;
            let paginationItem = target.closest(selectors.paginationItem);
            let removeTag = target.closest(selectors.removeTag);
            let clearButton = target.closest(selectors.clearAllTagsButton);

            if (paginationItem) {
                e.preventDefault();

                fetchArticles(paginationItem.getAttribute('href')).then(() => {
                    toggleLoader(false);
                });
            }

            if (removeTag) {
                deleteTag(removeTag);
            }

            if(clearButton) {
                deleteAllTags();
            }
        });

        filterCheckboxes.forEach(function (filterCheckbox) {
            filterCheckbox.addEventListener('change', toggleFilter);
            // Open by history
            filterCheckbox.addEventListener('changeWithHistory', toggleFilter);
        });

        accordionTriggers.forEach(function (accordionTrigger) {
            accordionTrigger.addEventListener('click', toggleAccordion);
        });

        popupTriggers.forEach(function (popupTrigger) {
            popupTrigger.addEventListener('click', function (){
                togglePopup();
            });
        });

        // Check and open by history
        if (queryParams.has('q')) {
            const params = queryParams.get('q').split('***');

            if (!params.length) return false;

            params.forEach((el, index) => {
                if (!el) return false;
                const lastIndex = (index === params.length - 1);
                const input = document.querySelector(`input[value=${el}]`);

                input.checked = true;
                input.dispatchEvent(new CustomEvent("changeWithHistory", {
                    detail: {
                        update: lastIndex,
                    },
                }));
            });
        }
    }

    function searchAction(event) {
        const searchInput = event.target.closest(selectors.searchInput);

        if (!searchInput || (!searchValue.length && !searchInput.value.length)) return;

        searchValue = searchInput.value;

        dynamicUrlFiltration = generateUrl();

        fetchArticles(dynamicUrlFiltration).then(() => {
            toggleLoader(false);
        });
    }
    function debounce(callback, wait, immediate) {
        let timeout = null;

        return function (...args) {
            const later = function () {
                timeout = null;
                if (!immediate) {
                    callback.apply(this, args);
                }
            };

            const callNow = immediate && !timeout;
            window.clearTimeout(timeout);
            timeout = window.setTimeout(later, wait);

            if (callNow) {
                callback.apply(this, args);
            }
        };
    }

    initPage();
});